import { render, staticRenderFns } from "./TheNavbarMenuProjectTab.vue?vue&type=template&id=7e3efd1c&"
import script from "./TheNavbarMenuProjectTab.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheNavbarMenuProjectTab.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports